var map = {
	"./agiliza/logo.svg": "9e29",
	"./ancora/logo.svg": "c854",
	"./autobanking/logo.svg": "f49e",
	"./gente/logo.svg": "d43a",
	"./girocred/logo.svg": "3074",
	"./ideal_veiculos/logo.svg": "c866",
	"./lucash/logo.svg": "c3b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a87e";